import _ from 'lodash';
import ResultsFilter from '../helpers/resultsFilter';

export default function getters() {
	return {
		getLoading: state => state.loading,
		getCategory: state => state.category,
		hasMovables: state => state.category === 1 || state.category === 3,
		getRealEstate: state => state.real_estate,
		getCalculation: state => state.calculation,
		getDataByGroup: state => (group, index = null) => (index === null ? state[group] : state[group][index]),
		getInsuranceEvents: state => state.baseData.insurance_events,
		getInsuranceEventNameById: state => id => {
			const insuranceEvent = _.find(state.baseData.insurance_events.extend, event => event.id === id);

			if (insuranceEvent !== undefined) {
				return insuranceEvent.name;
			}
		},
		getPremiseTypes: state => state.baseData.premise_types,
		getOutbuildingTypes: state => state.baseData.outbuildingTypes,
		getOutbuildingLocations: state => state.baseData.outbuildingLocations,
		getOutbuildingTypeById: state => id => state.baseData.outbuildingTypes[id],
		getOutbuildingLocationById: state => id => state.baseData.outbuildingLocations[id],
		getSearchResult: state => state.baseData.searchResult,
		getSearchResultByGroup: state => (type = null, group = null) => {
			if (group !== undefined && group !== null) {
				if (state.baseData.searchResult[group] !== undefined) {
					if (state.baseData.searchResult[group][type] !== undefined) {
						return state.baseData.searchResult[group][type];
					}
				}
			}

			return [];
		},
		getMovableTypes: state => state.baseData.movable_types,
		isCheckedEvent: state => (id, temp = false) =>
			temp ? state.temp.insurance_events.includes(id) : state.insurance_events.includes(id),
		getSelectedInsuranceEvents: state => (temp = false) =>
			temp ? state.temp.insurance_events : state.insurance_events,
		getCurrentStep: state => state.currentStep,
		getPopup: state => state.popup,
		getPopupHasClose: state => state.popupHasClose,
		getSteps: () => [
			'home',
			'is-company',
			'property-details',
			'movable',
			'contract-details',
			'package-information',
			'comparison',
			'comparing-two-offers',
		],
		getOutbuildings: state => state.outbuildings,
		getBuildings: state => state.buildings,
		getPremiseCount: state => type_id => state.premises.filter(premise => premise.type_id === type_id).length,
		getPremiseSum: state => Math.round(_.sumBy(state.premises, premise => premise.floor_area * premise.multipler)),
		getMovableSum: state => _.sumBy(state.movables, 'insurance_value'),
		getValuableSum: state => _.sumBy(state.valuables, 'insurance_value'),
		getMovables: state => state.movables,
		getValuables: state => state.valuables,
		getPremises: state => state.premises,
		getResponseOffers: state => state.offers,
		getOffersSum: state => _.countBy(state.offers, offer => offer.success),
		getOffer: state => insurer_uuid => _.find(state.offers, offer => offer.insurer_uuid === insurer_uuid),
		getOffers: state => orderBy => {
			const resultsFilter = new ResultsFilter(state.offers, state.insurance_events);
			return resultsFilter.getOrderedResults(orderBy);
		},
        getOffersRaw: state => state.offers,
		getInsurerNumbers: state => {
			return {
				insurer: _.uniq(
					_.map(
						_.filter(state.offers, offer => offer.success),
						offer => offer.insurer_code,
					),
				).length,
				product: _.uniq(
					_.map(
						_.filter(state.offers, offer => offer.success),
						offer => offer.product_name,
					),
				).length,
			};
		},
		getSelectedOffers: state => state.selectedOffers,
		getMobileMenu: state => state.mobile_menu,
		getRealEstates: state => state.real_estates,
		getSelectedUser: state => state.selectedUser,
		getEventIsInactive: state => id => state.inactive_events.includes(id),
		getWsErrors: state => state.wsErrors,
		getStateData: state => prop => state[prop],
		getQuestionAnswers: state => state.questionAnswers,
		getHasParcelNumber: state => state.hasParcelNumber,
		getHasHouseNumber: state => !state.hasParcelNumber,
		getInsuranceValueIsRandom: state => {
			if(state.insuranceValueIsRandom) {
				return false;
			}

			return state.real_estate.insurance_value !== null
				&& state.real_estate.insurance_value > 0;
		},
		getIsApartment: state => state.real_estate.type === 0,
		hasError: state => state.error,
		getMakeNotify: state => state.makeNotify,
		hasBuildings: state =>
			(state.category === 1 || state.category === 2) &&
			state.real_estate.type !== 0 &&
			state.real_estate.type !== null,
		hasOutbuildings: state => state.outbuildings.length > 0,
		getIsCheckPaymentMethod: state => state.calculation.payment_method === 0,
        getIsBusinessProcess: state => state.is_business_process,
        getBikaRealEstate: state => state.bikaRealEstate,
        getLoadedAddress: state => state.loadedAddress,
        getLoadingBikaId: state => state.loadingBikaId,
        getOtherConsultantName: state => state.otherConsultantName,
        getMatchingRealEstateUsers: state => state.matchingRealEstateUsers,
        getBikaImportInvalidEmail: state => state.bikaImportInvalidEmail,
        getIsCampaignCalculation: state => state.is_campaign_calculation,
        getOnMyOwn: state => state.onMyOwn,
	};
}
